
      import { macroCondition, getGlobalConfig, importSync } from '@embroider/macros';
      let config;
      if (macroCondition(getGlobalConfig().fastboot?.isRunning)){
        config = {
  "modulePrefix": "vagrant",
  "environment": "production",
  "APP": {
    "pollingInterval": 6000
  }
};
      } else {
        config = importSync('./_environment_browser_.js').default;
      }
      export default config;
    